<template>
  <div class="page page-checkup">
    <div class="page-title">Метрики</div>

    <div
      v-if="showSubmittedMsg"
      class="flash flash_success">
      <strong>Метрики отправлены.</strong>
    </div>

    <div v-if="!isLoaded" class="loader"></div>
    <div v-else-if="prescriptions.length === 0"
         class="checkup-empty">
      У вас нет назначенных метрик.
    </div>

    <div
      v-if="todayAnswers"
      class="flash">
      <p>Сегодня метрики уже были отправлены</p>
      <p>Врач просматривает изменение ваших метрик перед каждой консультацией.</p>
      <p>В случае сильного изменения самочувствия, напишите ассистенту для оперативной связи с врачом</p>
    </div>

    <div>
      <CheckupItem
        v-for="item in prescriptions"
        :key="item.id"
        :item="item"
        v-on:update-fields="updateFields" />
    </div>

    <div
      v-if="prescriptions.length > 0 && sendingResult === false"
      class="button button-send-checkup"
      @click="submit">Отправить форму
    </div>
  </div>
</template>

<script>
  import CheckupItem from './checkup/Item';

  export default {
    name: 'Checkup',

    components: {CheckupItem},

    data() {
      return {
        answers: [],
        showSubmittedMsg: false,
        sendingResult: false,
      };
    },

    computed: {
      isLoaded() {
        return this.$store.state.checkup.loaded;
      },

      todayAnswers() {
        const now = new Date();

        now.setHours(0);
        now.setMinutes(0);
        now.setSeconds(0);

        return this.$store.state.checkup.answers.find(answer => {
          const date = new Date(answer.createdAt);

          return date.getTime() > now.getTime();
        });
      },

      prescriptions() {
        if (this.todayAnswers) {
          return [];
        }

        const prescriptions = this.$store.state.checkup.prescriptions.filter(prescription => {
          return prescription.active === true;
        });

        prescriptions.sort((a, b) => a.item.sort - b.item.sort);

        return prescriptions.map(prescription => {
          const answers = this.answers[prescription.item.id] || [];

          const fields = prescription.item.fields.map(field => {
            const { id, label, sort, type, note } = field;
            const inSelected = answers.find(i => i.field === id);
            const selected = typeof inSelected !== 'undefined';

            return { id, label, sort, type, note, selected };
          });

          fields.sort((a, b) => a.sort - b.sort);

          return {
            id: prescription.item.id,
            title: prescription.item.title,
            catalog: prescription.item.catalog,
            sort: prescription.item.sort,
            multiple: prescription.item.multiple,
            type: prescription.item.type,
            description: prescription.item.description,
            fields,
            active: prescription.active,
          }
        });
      }
    },

    methods: {
      updateFields(data) {
        const { item, fields } = data;

        this.answers[item] = fields;

        this.answers = Object.assign({}, this.answers);
      },

      async submit() {
        const data = {answers: []};

        if (this.sendingResult) {
          return;
        }

        this.sendingResult = true;

        for (const item of Object.keys(this.answers)) {
          for (const { field, value } of this.answers[item]) {
            data.answers.push({ field, value });
          }
        }

        try {
          await this.$store.dispatch('POST_CHECKUP_ANSWERS', data);

          this.showSubmittedMsg = true;
        } catch(e) {
          await this.$store.dispatch('ERROR', e);
        }
      },
    },
  }
</script>

<style lang="scss">
  @import "../assets/scss/variables.scss";

  .page-checkup {
    padding-bottom: 10px;

    .checkup-empty {
      text-align: center;
    }

    .button-send-checkup {
      display: block;
      width: 80%;
      margin: 30px auto 10px;
      padding: 10px 10px;
      background-color: $primary;
      border-radius: 20px;
      text-align: center;
    }
  }
</style>
